<template>
  <div class="sl_pagination">
    <div v-if="count > 0" class="sl_pagination__text">
      <span>{{ ((page - 1) * limit) + 1 }}-{{ page * limit }} of {{ count }}</span>
    </div>
    <div class="sl_pagination__paginations--btns">
      <button @click="prevPage" :class="{ active: page > 1 }"
         class="sl_pagination__paginations--btns_prev"><i class="material-icons">navigate_before</i></button>
      <button @click="nextPage" :class="{ active: page < pagesCount }"
         class="sl_pagination__paginations--btns_next"><i class="material-icons">navigate_next</i></button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Pagination',
    props: ['page', 'count', 'limit', 'pagesCount'],
    methods: {
      nextPage() {
        this.$emit('changePage', Math.min(this.pagesCount, this.page + 1))
      },
      prevPage() {
        this.$emit('changePage', Math.max(1, this.page - 1))
      },
    },
  }
</script>
